import { useNavigate } from 'react-router-dom';

import { ActionText } from '@components/action-text';
import { Banner } from '@components/banner';
import { IconPlan } from '@components/icons/icon-plan';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';
import { pxToRem } from '@utils/converters';

import { useIsOutOfCredits } from 'api/authentication/hooks';
import { routePaths } from 'ui/authenticated/navigation';

export const OutOfCreditsBanner = () => {
  const { t, styledTranslate } = useScopedTranslate(locale);
  const isOutOfCredits = useIsOutOfCredits();
  const navigate = useNavigate();

  return !isOutOfCredits ? null : (
    <Banner
      title={
        <Text
          font="regular14"
          text={styledTranslate('title', {
            upgrade: (
              <ActionText.Link
                font="regular16"
                color="indigo200"
                to={routePaths.subscriptionPlans}
                underline
              >
                {t('upgrade')}
              </ActionText.Link>
            ),
          })}
        />
      }
      variant="indigo"
      buttonProps={{
        text: t('upgradePlan'),
        variant: 'indigo',
        iconLeft: <IconPlan color="white100" />,
        onClick: () => navigate(routePaths.subscriptionPlans),
      }}
      icon={
        <IconPlan
          color="purpleTrans10"
          size={160}
          style={{ transform: `translateY(${pxToRem(56)}) translateX(${pxToRem(-8)})` }}
          rotateDegrees={45}
        />
      }
    />
  );
};

const locale = {
  en: {
    title: 'Monthly credit balance reached. {upgrade}',
    upgrade: 'Upgrade or buy credits to avoid interruptions',
    upgradePlan: 'Upgrade plan',
  },
};
